// DJB-218: the price sheet of a payment mode has no stored URL — it lives in
// the public S3 bucket root under keys implied by the payment mode id, exactly
// where the jukebox client (PaymentModeDirectory.updatePaymentmodeCoverart)
// downloads it from: {id}-small.png is the sheet the jukebox shows, {id}.png
// is stored alongside it with the same image.
export const S3_PUBLIC_BASE_URL = 'https://tdj-s3.s3.eu-west-2.amazonaws.com/';

// `version` is a cache buster: uploads overwrite the object in place, so the
// browser must be forced past its cached copy after a replace.
export const priceSheetSmallUrl = (paymentModeId, version) =>
  `${S3_PUBLIC_BASE_URL}${paymentModeId}-small.png${version ? `?cb=${version}` : ''}`;

// The box the jukebox renders the sheet in (PriceInfoCard, 430×130); the image
// is stored 1:1, and DJB-Server rejects any other size — mirror that check here
// so a wrong pick fails before the upload round-trip.
export const PRICE_SHEET_WIDTH = 430;
export const PRICE_SHEET_HEIGHT = 130;

export const PRICE_SHEET_FILE_ERROR = 'The price sheet must be a PNG image.';

export const priceSheetSizeError = ({ width, height }) =>
  `The price sheet must be ${PRICE_SHEET_WIDTH}×${PRICE_SHEET_HEIGHT} pixels (got ${width}×${height}).`;

// Pixel size of a picked File, or null where it cannot be read (no object
// URLs / Image in this environment, or the file does not decode) — the backend
// validates again either way.
export const readImageDimensions = (file) =>
  new Promise((resolve) => {
    if (typeof URL.createObjectURL !== 'function' || typeof Image === 'undefined') {
      resolve(null);
      return;
    }
    const url = URL.createObjectURL(file);
    const image = new Image();
    const finish = (dimensions) => {
      if (typeof URL.revokeObjectURL === 'function') URL.revokeObjectURL(url);
      resolve(dimensions);
    };
    image.onload = () => finish({ width: image.naturalWidth, height: image.naturalHeight });
    image.onerror = () => finish(null);
    image.src = url;
  });

// Resolves to an error message for a picked file, or null when it is acceptable.
export const validatePriceSheetFile = async (file, isPng) => {
  if (!isPng(file)) return PRICE_SHEET_FILE_ERROR;
  const dimensions = await readImageDimensions(file);
  if (
    dimensions &&
    (dimensions.width !== PRICE_SHEET_WIDTH || dimensions.height !== PRICE_SHEET_HEIGHT)
  ) {
    return priceSheetSizeError(dimensions);
  }
  return null;
};
